import React, { lazy, Suspense } from 'react';
import { Helmet } from 'react-helmet';
import { createBrowserRouter, RouterProvider } from 'react-router';
import LoadingStatusComponent from 'src/components/common/LoadingStatusComponent';

const AppMainLayout = lazy(() => import('src/components/AppMainLayout'));
const WidgetMainLayout = lazy(() => import('src/components/WidgetMainLayout'));

export const routes = [
  {
    path: '/irc/widget',
    element: (
      <Suspense fallback={<LoadingStatusComponent />}>
        <WidgetMainLayout />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: (
      <Suspense fallback={<LoadingStatusComponent />}>
        <AppMainLayout />
      </Suspense>
    ),
  },
];

export default function App() {
  return (
    <>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Helmet>
      <RouterProvider router={createBrowserRouter(routes)} />
    </>
  );
}
